<template>
  <div>
    <div class="container container_com-fundo container_com-margem">
      <section>
        <main class="conteudo-principal columns">
          <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
          <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
          <div class="columns search buscar-solicitacoes no-print">
            <div class="formulario">
              <h2 class="titulo titulo_grande u-margem-inferior-media u-margem-esquerda-pequena">
                Selecione o projeto para inserir novo valor de aporte e visualizar os aportes já efetuados
              </h2>
              <div class="grade__linha grade__linha_alinhar-vertical-a-base">
                <div class="grade__coluna grade__coluna_3">
                  <label for="projeto">Projeto</label>
                  <select id="projeto" name="projeto" v-model="projeto">
                    <option v-for="projeto in projetos" :value="projeto">
                      {{ projeto.Nome }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </main>
      </section>
    </div>
    <div class="container container_com-fundo container_com-margem" v-if="projeto.Id != null">
      <section>
        <div
          class="grade__linha informacoes-resultado-filtro no-print grade__linha_distribuir-horizontal-entre-elementos">
          <div class="grade__coluna grade__coluna_9">
            <h2 class="titulo titulo_grande u-margem-inferior-media">
              {{ this.obterNomeDoProjetoSelecionado() }}
            </h2>
          </div>
          <div class="grade__coluna grade__coluna_3 u-texto-alinhado-a-direita">
            <router-link v-if="projeto" :to="rotaCadastroAporte" class="botao botao_cor-terciaria botao_medio">
              <span>Inserir novo aporte</span>
            </router-link>
          </div>
        </div>
        <hr class="u-margem-inferior-media">
        <TabelaDeAportesDoProjeto v-if="projeto.Tipo === 'Projeto' && projeto.Aportes" :aportes="projeto.Aportes" />
        <TabelaDeAportesDoMcmvCidades v-if="projeto.Tipo === 'McmvCidades' && projeto.AportesDoMcmvCidades"
          :aportes="projeto.AportesDoMcmvCidades" />
      </section>
    </div>
  </div>
</template>

<script>
import Loading from '../shared/Loading';
import Alerta from '../shared/Alerta';
import TabelaDeAportesDoProjeto from './TabelaDeAportes';
import TabelaDeAportesDoMcmvCidades from './mcmv-cidades/TabelaDeAportes';

export default {
  name: 'lista-de-aportes',
  components: { Loading, Alerta, TabelaDeAportesDoProjeto, TabelaDeAportesDoMcmvCidades },
  data() {
    return {
      projetos: this.projetos || [],
      projeto: {},
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      tipoDeAlerta: null,
    };
  },
  created() {
    let projetoPadrao = { Id: null, Nome: 'Selecione o projeto', Aportes: new Array() };
    this.projeto = projetoPadrao;
    this.projetos = [projetoPadrao];

    this.obterProjetos();
  },
  computed: {
    rotaCadastroAporte() {
      return this.projeto.Tipo === 'McmvCidades'
        ? { name: 'CadastroDeAporteMcmv', params: { projetoId: this.projeto.Id } }
        : { name: 'CadastroDeAporte', params: { projetoId: this.projeto.Id } };
    }
  },
  methods: {
    obterProjetos() {
      this.exibirCarregamento();
      this.$api.get('/Projeto/ObterComAportes').then((response) => {
        this.esconderCarregamento();
        this.projetos = this.projetos.concat(response.data);
        let projetoId = this.$route.params.projetoId;

        if (projetoId)
          this.projeto = this.obterProjeto(projetoId);
      }).catch((error) => {
        this.tratarErro(error);
      });
    },
    obterProjeto(projetoId) {
      let projeto = this.projetos.find(projeto => projeto.Id == projetoId);
      return projeto;
    },
    obterNomeDoProjetoSelecionado() {
      let projeto = this.obterProjeto(this.projeto.Id);
      return projeto === undefined ? '' : projeto.Nome;
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    tratarErro(error) {
      this.esconderCarregamento();
      this.tipoDeAlerta = 'erro';
      let mensagensDeErro = error.response.data.Message;
      this.mensagemDeAlerta = mensagensDeErro || 'Ocorreu um erro interno. Tente novamente ou contate o suporte';
    }
  }
};
</script>



// WEBPACK FOOTER //
// ListaDeAportes.vue?3b0790da